import { render, staticRenderFns } from "./GeneralAdmissionRules.vue?vue&type=template&id=bc8b1824"
import script from "./GeneralAdmissionRules.vue?vue&type=script&lang=js"
export * from "./GeneralAdmissionRules.vue?vue&type=script&lang=js"
import style0 from "./GeneralAdmissionRules.vue?vue&type=style&index=0&id=bc8b1824&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports